import _ from "lodash";

export const AUTHLEVEL = Object.freeze({
  free: Symbol(`free`), // used with lock UI
  paid: Symbol(`paid`), // used with lock UI
  freeOnly: Symbol(`free only`), // used with pruneUI
  paidOnly: Symbol(`paid only`), // used with pruneUI
  all: Symbol(`all`)
});

// [{component: JSX, auth: Symbol, a}] -> JSX -> Symbol -> [{src: JSX, auth: Symbol, a}]
export const lockUI = (UI, auth, lockReplacement) =>
  _.map(UI, screen =>
    screen.auth === auth
      ? _.extend({}, screen, { component: lockReplacement })
      : screen
  );

// [{component: JSX, auth: Symbol, a}] -> Symbol -> [{src: JSX, auth: Symbol, a}]
export const pruneUI = (UI, auth) =>
  _.filter(UI, screen => screen.auth !== auth);

// [{component: JSX, auth: Symbol, a}] -> JSX -> [Symbol] -> [Symbol] -> [{src: JSX, auth: Symbol, a}]
export const prepUI = _.curry(
  (UI, lockReplacement, authsToPrune, authsToLock) => {
    let temp = UI;
    temp = _.reduce(
      authsToLock,
      (acc, cur) => lockUI(acc, cur, lockReplacement),
      temp
    );
    temp = _.reduce(authsToPrune, (acc, cur) => pruneUI(acc, cur), temp);
    return temp;
  }
);
